import { Link } from "react-router-dom";
import {Plus, Edit, Delete} from 'react-feather'
import { useContext, useState, useEffect } from "react";
import { appContext } from "../Context/appContext";
import { api } from "../helpers";
import { access, baseURL, MAIN_COLOR, path } from "../constants";
import Loader from "../Components/Loader";
import Select from 'react-select'
import { customStyles } from "../Components/AddTenant";

export default function TenantUsers(){
    const {toggleAUser, showAddUser, setShowAddUser, showMessage, setConfirm} = useContext(appContext)
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [tenants, setTenants] = useState([])
    const [selectedTenant, setSelectedTenant] = useState({})

    const fetchUsers = (tenantId) => {
        setLoading(true)
        api.get(path.tenantUser + '?tenantid=' + tenantId).then(response => {
            const data = response.data
            if(data.success){
                setUsers(data.users)
            } else showMessage('Something went wrong', true)
        }).catch(e => showMessage('Something went wrong', true))
        .finally(() => setLoading(false))
    }

    const fetchTenants = () => {
        setLoading(true)
        api.get(path.tenant).then(response => {
            const data = response.data
            if(data.success){
                setTenants(data.tenants.map(t => ({label: t.short_name, value: t.id})))
            } else showMessage('Something went wrong', true)
        }).catch(e => showMessage('Something went wrong', true))
        .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(!showAddUser.visible && selectedTenant.value) {
            fetchUsers(selectedTenant.value)
        }
    }, [showAddUser, selectedTenant])

    useEffect(() => {
        fetchTenants()
    }, [])

    useEffect(() => {
        setShowAddUser(s => ({...s, tenantId: selectedTenant.value}))
    }, [selectedTenant])

    const deleteUser = (id) => {
        return function(){
            return api.delete(path.tenantUser, {
                data: {id}}
            ).then(r => {
                setUsers(m => m.filter(i => i.id != id))
                showMessage('User deleted', false)
            }).catch(e => showMessage('Something went wrong', true))
            .finally(() => setLoading(false))
        }
    }

    return (
        <div className='flex flex-col flex-1 overflow-auto p-6 gap-6'>
        <button onClick={() => {
            if(!selectedTenant.value) return showMessage('Please select a tenant!', true)
            toggleAUser()
        }} className='self-end bg-main px-4 p-2 rounded-sm font-bold  text-white flex items-center gap-2 hover:bg-darker transition-all border-none'>
            Create User ({selectedTenant.label})
            <Plus color="#ffffff" size={18} />
        </button>
        <div className='flex items-center gap-4'>
            <p className='text-[16px] uppercase font-bold'>Tenant Users</p>
            <Select onChange={setSelectedTenant} options={tenants} value={selectedTenant} styles={customStyles} className='w-[250px] z-[99999]' name="tenant"  />
        </div>
        <div className='overflow-y-auto flex-1 rounded-md bg-white p-0 flex flex-col'>
        <table className='w-full'>
            <thead>
                <tr>
                    <th>
                        Username
                    </th>
                    <th>
                        Role
                    </th>
                    <th>
                        Created At
                    </th>
                    <th>
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {users.map(user => (
                    <tr> 
                         <td>{user.username}</td>
                         <td>{user.role}</td>
                         <td>{user.createdAt?.split('.')[0]}</td>
                         <td className='flex items-center justify-center'>
                             <button onClick={() => toggleAUser(user)} className='border-none bg-none'>
                                 <Edit color='#000000' size={20} />
                             </button>
                             <button onClick={() => setConfirm({
                                 visible: true,
                                 action: deleteUser(user.id)
                                 }) } className='border-none bg-none ml-3'>
                                 <Delete color="#ff0000" size={20} />
                             </button>
                         </td>
                    </tr>
                ))}
            </tbody>
        </table>
        {(!loading && !users.length) && <h4 className='text-center mt-4'>No Data.</h4>}
        <Loader text={null} loading={loading} color={MAIN_COLOR} style={{marginTop: 20, alignSelf: 'center'}} />
        </div>
    </div>
    )
}
